import { Box } from '@common-fe/common-fe';
import styled, { css, keyframes } from 'styled-components';

export const warningShake = keyframes`
  0%, 100% { transform: translateX(0); }
  15%      { transform: translateX(-8px); }
  30%      { transform: translateX(8px); }
  45%      { transform: translateX(-6px); }
  60%      { transform: translateX(6px); }
  75%      { transform: translateX(-3px); }
  90%      { transform: translateX(3px); }
`;

export const ShakeBox = styled(Box)<{ $shake?: boolean }>`
  ${({ $shake }) => $shake && css`
    animation: ${warningShake} 0.4s ease;
  `}
`;

export const ClickableRow = styled(Box)`
  cursor: pointer;
`;

export const CheckboxGuard = styled(Box)<{ $locked?: boolean }>`
  ${({ $locked }) => $locked && css`
    cursor: pointer;
    input {
      pointer-events: none;
    }
  `}
`;
